(function(){'use strict';
function init(root){
  if(!root||root.dataset.bpbEnhancements==='true')return;
  root.dataset.bpbEnhancements='true';

  root.querySelectorAll('[data-bpb-ask-refill]').forEach(function(button){
    button.addEventListener('click',function(){
      var launcher=document.querySelector('.bb-chat-launcher');
      if(launcher)launcher.click();
    });
  });

  root.querySelectorAll('[data-bpb-compatible-refill-add]').forEach(function(button){
    button.addEventListener('click',function(){
      var offer=button.closest('[data-bpb-refill-fbt]');
      var selected=offer?offer.querySelector('input[type="radio"]:checked'):null;
      var variantId=Number(selected?selected.value:button.getAttribute('data-variant-id'))||0;
      var status=offer?offer.querySelector('[data-bpb-refill-status]'):null;
      if(!variantId)return;
      var original=button.textContent;
      button.disabled=true;
      button.textContent='Adding…';
      if(status)status.hidden=true;
      fetch(((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/').replace(/\/?$/,'/')+'cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        credentials:'same-origin',
        body:JSON.stringify({items:[{id:variantId,quantity:1}]})
      }).then(function(response){
        return response.json().catch(function(){return {}}).then(function(data){
          if(!response.ok)throw new Error(data.description||data.message||'Refill could not be added.');
          return data;
        });
      }).then(function(){
        button.textContent='Added ✓';
        button.classList.add('is-added');
        if(status){status.textContent='Selected refill added to your cart.';status.hidden=false;status.classList.add('is-success');}
      }).catch(function(error){
        button.disabled=false;
        button.textContent=original;
        if(status){status.textContent=error.message||'Refill could not be added.';status.hidden=false;status.classList.remove('is-success');}
      });
    });
  });
}
function boot(){document.querySelectorAll('[data-bpb-pdp]').forEach(init)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
document.addEventListener('shopify:section:load',boot);
})();
